import SecretQuestions from './SecretQuestions'
export default SecretQuestions
